import { render, staticRenderFns } from "./CommonManufacturerForm.vue?vue&type=template&id=cc523698&"
import script from "./CommonManufacturerForm.vue?vue&type=script&lang=js&"
export * from "./CommonManufacturerForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports